__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/64d6be3/_next/";